import React, { useRef } from 'react';

import BlockContent from '@sanity/block-content-to-react';
import richText from '../serializers/richText';
import useIntersection from 'buena-suerte/lib/hooks/useIntersection';
import classNames from 'classnames';

export default ({ content }) => {
  const intersectionRef = useRef();
  const isIntersected = useIntersection(intersectionRef);
  return (
    <section
      ref={intersectionRef}
      className={classNames(
        'spotlight__body-text sans--sm sans--md--md p2 pt5--lg pb5--lg rich-text reveal',
        { revealed: isIntersected }
      )}
    >
      <BlockContent blocks={content} serializers={richText} />
    </section>
  );
};
